import React from 'react';
import { getInitial } from '../utils/displayName';
import { resolveImageUrl as resolveSrc } from '../utils/imageUrl';

export const Avatar = ({
  src,
  name,
  sizeClass = 'w-10 h-10',
  textClass = 'text-sm',
  className = '',
  gradientClass = 'from-emerald-400 to-green-500',
  testId,
}) => {
  const [errored, setErrored] = React.useState(false);
  const showImage = src && !errored;

  return (
    <div
      className={`${sizeClass} rounded-full overflow-hidden flex-shrink-0 flex items-center justify-center ${
        showImage ? '' : `bg-gradient-to-br ${gradientClass}`
      } ${className}`}
      data-testid={testId}
    >
      {showImage ? (
        <img
          src={resolveSrc(src)}
          alt={name || 'avatar'}
          className="w-full h-full object-cover"
          onError={() => setErrored(true)}
        />
      ) : (
        <span className={`text-white font-semibold ${textClass}`}>{getInitial(name)}</span>
      )}
    </div>
  );
};

export default Avatar;
